<template>
  <footer class="mt-4 mb-4 animated">
    <img id="mingava-logo" :height="height" :width="width" src="/min_gava_logo.png" contain eager />
    <p class="text-center mt-5 mb-0 grey--text text--darken-2 caption">
      {{ t('logoFooter.subtitle') }}
    </p>
    <p class="text-center mt-1 blue--text text--darken-2 caption">
      <v-btn
        id="accessibility-statement-toggle"
        color="primary"
        variant="plain"
        size="x-small"
        :ripple="false"
        aria-controls="accessibility-statement-dialog"
        @click="showAccessibilityStatement = !showAccessibilityStatement"
      >
        {{ t('logoFooter.accessibilityStatementLinkText') }}
      </v-btn>
    </p>
    <p class="text-center mt-0 blue--text text--darken-2 caption">
      <v-btn
        id="available-payment-method-info-toggle"
        color="primary"
        variant="plain"
        size="x-small"
        :ripple="false"
        aria-controls="available-payment-method-info-dialog"
        @click="openPaymentMethodDialog"
      >
        {{ t('availablePaymentMethod.title') }}
      </v-btn>
    </p>

    <!-- Support Hint -->
    <p class="text-center mt-5 mb-0 grey--text text--darken-2 caption">
      {{ t('logoFooter.supportHint') }}
    </p>
    <p class="text-center mt-2 mb-0 grey--text text--darken-2 caption">
      <a href="mailto:kundtjanst@mingava.se" :aria-label="t('logoFooter.aria.emailSupport')"> {{ t('logoFooter.supportEmail') }} </a>
    </p>
    <p class="text-center mt-2 grey--text text--darken-2 caption">
      <a
        :href="'tel:' + t('logoFooter.supportPhone')"
        :aria-label="t('accessibilityStatement.contact.phoneLabel', { email: t('logoFooter.supportPhone') })"
      >
        {{ t('logoFooter.supportPhone') }}
      </a>
    </p>
    <v-dialog
      id="accessibility-statement-dialog"
      v-model="showAccessibilityStatement"
      data-cy="accessibility-dialog"
      aria-labelledby="accessibility-statement-dialog-title"
      aria-modal="true"
      max-width="600"
    >
      <v-card flat>
        <v-card-title
          id="accessibility-statement-dialog-title"
          class="text-center headline mx-auto"
        >
          <div class="accessibility-title-text">{{ t('accessibilityStatement.header') }}</div>
          <v-spacer />
          <v-btn
            id="accessibility-statement-toggle-close"
            variant="text"
            icon
            data-cy="accessibility-dialog-close-btn"
            :aria-label="t('accessibilityStatement.dialogCloseLabel')"
            @click="showAccessibilityStatement = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <accessibility-statement-component />
      </v-card>
    </v-dialog>

    <v-dialog
      id="available-payment-method-info-dialog"
      v-model="showAvailablePaymentMethodInfo"
      data-cy="available-payment-method-dialog"
      aria-labelledby="available-payment-method-info-dialog-title"
      aria-modal="true"
      max-width="600"
    >
      <v-card flat>
        <v-card-title
          id="available-payment-method-info-dialog-title"
          class="text-center headline mx-auto"
        >
          <div class="accessibility-title-text">{{ t('availablePaymentMethod.title') }}</div>
          <v-spacer />
          <v-btn
            id="available-payment-method-info-close"
            variant="text"
            icon
            data-cy="available-payment-method-dialog-close-btn"
            :aria-label="t('accessibilityStatement.dialogCloseLabel')"
            @click="showAvailablePaymentMethodInfo = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <available-payment-method-info />
      </v-card>
    </v-dialog>
  </footer>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import AccessibilityStatementComponent from '@/components/global/AccessibilityStatementComponent.vue';
import AvailablePaymentMethodInfo from '@/components/global/AvailablePaymentMethodInfo.vue';
import { useLabel } from '@/composables/useLabel';
import matomo from '@/services/matomoService';
export default defineComponent({
  components: { AccessibilityStatementComponent, AvailablePaymentMethodInfo },
  props: {
    height: { type: Number, default: 40 },
    width: { type: Number, default: 40 },
  },
  setup() {
    const { t } = useLabel();
    const showAccessibilityStatement = ref(false);
    const showAvailablePaymentMethodInfo = ref(false);
    const openPaymentMethodDialog = () => {
      showAvailablePaymentMethodInfo.value = !showAvailablePaymentMethodInfo.value;
      matomo.trackEvent('Footer', 'Clicked', 'Payment Methods Link');
    };

    return {
      t,
      showAccessibilityStatement,
      showAvailablePaymentMethodInfo,
      openPaymentMethodDialog
    };
  },
});
</script>
<style scoped>
#accessibility-statement-dialog-title,
#available-payment-method-info-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

#accessibility-statement-dialog-title .accessibility-title-text,
#available-payment-method-info-dialog-title .accessibility-title-text {
  display: block;
  white-space: normal;
  text-align: center;
  font-size: 20px;
  padding-left: 15px;
  word-break: break-word;
}

#mingava-logo {
  display: flex;
  justify-self: center;
  object-fit: contain;
  width: 100%;
}
</style>
